import { ExecutionMode } from '../types';

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  MCP_SERVER_PAGE_SIZE: 50,
  TOOLSET_PAGE_SIZE: 20,
  DIALOG_PAGE_SIZE: 20,
  TOOL_PAGE_SIZE: 20,
  DIALOG_TOOLSET_PAGE_SIZE: 50,
  API_TIMEOUT_DELAY: 500,
} as const;

// Rate Limits
export const RATE_LIMITS = {
  DEFAULT_REQUESTS_PER_MINUTE: 200,
  DEFAULT_BURST: 50,
  DEFAULT_WINDOW_SECONDS: 60,
} as const;

// Execution
export const EXECUTION = {
  DEFAULT_TIMEOUT_MS: 30000,
  DEFAULT_MODE: ExecutionMode.Sync,
} as const;

// UI
export const UI = {
  COPY_FEEDBACK_DURATION: 2000,
  SCROLL_THRESHOLD: 100,
  INCREMENTAL_LOAD_COUNT: 20,
  API_KEY_MASK: '•••••••••••••••••••',
  ICON_SIZES: {
    SMALL: 12,
    MEDIUM: 16,
    LARGE: 24,
  },
} as const;

// Tool Categories
export const TOOL_CATEGORIES = {
  DATA_ACCESS: 'Data Access',
  ACTION: 'Action',
} as const;

// Operation Types
export const OPERATION_TYPES = {
  READ: 'read',
  ACTION: 'action',
} as const;

// Data Classification
export const DATA_CLASSIFICATION = {
  INTERNAL: 'internal',
  PUBLIC: 'public',
  CONFIDENTIAL: 'confidential',
  RESTRICTED: 'restricted',
  DEFAULT_LEVEL: 'internal',
} as const;

// Audit
export const AUDIT = {
  DEFAULT_RETAIN_DAYS: 90,
} as const;

// API Endpoints and Paths
export const API = {
  TOOLS: '/tools',
  TOOLSETS: '/toolsets',
  EXPORTS: '/exports',
  MCP_SERVER: '/mcp',
} as const;
